import { SendersRepository } from '../repositories/senders.repository'
import {
    SenderPayloadT,
    SendersCreateSenderResponseT,
    SendersGetListResponseT,
    SendersSearchSenderResponseT,
} from '../types/senders.types'

const sendersRepository = new SendersRepository()

export class SendersService {
    async getList(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<SendersGetListResponseT> {
        const response = await sendersRepository.getList(page, company_id, city_id)
        return response.data
    }

    async createSender(payload: SenderPayloadT): Promise<SendersCreateSenderResponseT> {
        const response = await sendersRepository.createSender(payload)
        return response.data
    }

    async updateSender(id: number, payload: SenderPayloadT): Promise<SendersCreateSenderResponseT> {
        const response = await sendersRepository.updateSender(id, payload)
        return response.data
    }

    async updateSenderInOrder(id: number, payload: SenderPayloadT): Promise<void> {
        const response = await sendersRepository.updateSenderInOrder(id, payload)
        return response.data
    }

    async deleteSender(id: number): Promise<void> {
        await sendersRepository.deleteSender(id)
    }

    async searchSender(
        param: string,
        company_id: number,
        exact_city_id?: number
    ): Promise<SendersSearchSenderResponseT> {
        const response = await sendersRepository.searchSender(param, company_id, exact_city_id)
        return response.data
    }
}
